"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var React = require("react");
var BeforeConnectingDialog_1 = require("./BeforeConnectingDialog");
var browser_support_1 = require("@tableau/browser-support");
var WindowUtils_1 = require("./WindowUtils");
var widgets_1 = require("@tableau/widgets");
var OAuthCredentialsService = /** @class */ (function () {
    function OAuthCredentialsService() {
        var _this = this;
        this.hasOpenWindow = false;
        this.beforeYouConnectContainer = null;
        $(window).on('message', function (jqEvent) {
            // casted to <any> because JQueryEvent originalEvent is expected to be a PopStateEvent which is not compatible with MessageEvent
            var originalEvent = jqEvent.originalEvent;
            if (originalEvent.source !== _this.openWindow) {
                return;
            }
            var response = originalEvent.data;
            if (!(typeof response === 'string')) {
                return;
            }
            _this.handleResponse(response);
        });
        // The user is navigating away from this page so the popup is no longer needed, let's try to remove it for them.
        $(window).on('unload', function () { return _this.removeOpenWindow(); });
    }
    Object.defineProperty(OAuthCredentialsService.prototype, "OpenWindow", {
        get: function () {
            return this.openWindow;
        },
        enumerable: true,
        configurable: true
    });
    OAuthCredentialsService.IsClientSecure = function () {
        return window.location.protocol.toLowerCase() === 'https:';
    };
    OAuthCredentialsService.AddCredential = function (addCredentialParams) {
        OAuthCredentialsService.InitializeIfNeeded();
        OAuthCredentialsService.instance.AddCredentialImpl(addCredentialParams);
        // Return the open window to the caller so they will be able to close it manully if needed.
        return OAuthCredentialsService.instance.OpenWindow;
    };
    OAuthCredentialsService.InitializeIfNeeded = function () {
        if (!OAuthCredentialsService.instance) {
            OAuthCredentialsService.instance = new OAuthCredentialsService();
        }
    };
    OAuthCredentialsService.prototype.AddCredentialImpl = function (addCredentialParams) {
        this.addCredentialParams = addCredentialParams;
        if (addCredentialParams.bypassBeforeConnectingDialog) {
            this.ShowAddCredentialWindow();
        }
        else {
            this.ShowBeforeConnectingDialog(addCredentialParams);
        }
    };
    OAuthCredentialsService.prototype.ShowAddCredentialWindow = function () {
        var oauthCredentialInfo = { 'data_class': this.addCredentialParams.connectionType };
        if (this.addCredentialParams.instanceUrl) {
            oauthCredentialInfo.instanceURL = this.addCredentialParams.instanceUrl;
        }
        if (this.addCredentialParams.role) {
            oauthCredentialInfo.role = this.addCredentialParams.role;
        }
        var serialized = $.param(oauthCredentialInfo);
        var url = OAuthCredentialsService.OAuthPath
            + '?' + serialized + '&' + $.param({ 'secure': OAuthCredentialsService.IsClientSecure() });
        var specs = WindowUtils_1.getPopupSpecs();
        var options = WindowUtils_1.convertSpecsToParams(specs);
        // TFS 817300 - Edge does not support opening in a new window from an insecure (http) context
        this.openWindow = browser_support_1.BrowserSupport.IsEdge() ?
            window.open(url, '_blank') :
            window.open(url, OAuthCredentialsService.WindowName, options);
        try {
            this.openWindow.focus(); // Bring the newly opened window to the front
            this.hasOpenWindow = true;
        }
        catch (e) { /*No-op*/ }
    };
    OAuthCredentialsService.prototype.ShowBeforeConnectingDialog = function (addCredentialParams) {
        var _this = this;
        this.beforeYouConnectContainer = new widgets_1.HostedStackedElementContainer();
        var dialogProps = {
            connectionType: addCredentialParams.connectionType,
            connectionTypeDisplay: addCredentialParams.connectionTypeDisplay,
            onCancel: function () {
                _this.removeBeforeYouConnectDialog();
                addCredentialParams.onCancel();
            },
            onProceedSignIn: function () {
                _this.ShowAddCredentialWindow();
            },
            sendEventFn: addCredentialParams.sendEventFn
        };
        if (addCredentialParams.onProceedNoSignIn) {
            dialogProps = __assign({}, dialogProps, { onProceedNoSignIn: function () {
                    _this.removeBeforeYouConnectDialog();
                    addCredentialParams.onProceedNoSignIn();
                } });
        }
        var element = React.createElement(BeforeConnectingDialog_1.BeforeConnectingDialog, dialogProps);
        window.setTimeout(function () {
            _this.beforeYouConnectContainer.render(element);
        }, 0);
    };
    OAuthCredentialsService.prototype.handleResponse = function (response) {
        if (response === void 0) { response = ''; }
        var responseObj = this.safeJSONParse(response);
        if (this.addCredentialParams.supportsGenericAuth) {
            this.handleGenericAuthResponse(response, responseObj);
        }
        else {
            this.handleCustomOAuthResponse(response, responseObj);
        }
    };
    OAuthCredentialsService.prototype.handleGenericAuthResponse = function (response, responseObj) {
        if (responseObj.msgName === 'loaded') {
            // When the home page for WDC is loaded, post a message to initialize it
            this.sendInitAuthMessage();
        }
        else if (responseObj.msgName === 'submit') {
            this.saveGenericAuthCredentials(responseObj);
        }
    };
    OAuthCredentialsService.prototype.safeJSONParse = function (text) {
        var parsed = null;
        try {
            parsed = JSON.parse(text);
        }
        catch (e) {
            // Invalid JSON text.
        }
        // May be null
        return parsed;
    };
    OAuthCredentialsService.prototype.sendInitAuthMessage = function () {
        if (!this.hasOpenWindow) {
            return;
        }
        // For first-class WDC, load WDC url and send an init message to the window
        var emptyMessage = {
            'msgRecipient': 'webdataconnector',
            'msgName': OAuthCredentialsService.InitMsgName,
            'msgData': { 'phase': OAuthCredentialsService.AuthPhaseName },
            'props': {
                'authPurpose': 'enduring',
                'connectionName': '',
                'connectionData': '',
                'password': '',
                'username': '',
                'incrementalExtractColumn': '',
                'versionNumber': '2.0',
                'locale': this.helpUrlLanguage(this.addCredentialParams.sessionLanguage),
                'platformBuildNumber': this.addCredentialParams.sessionServerVersionBuild,
                'platformEdition': 'server',
                'platformOS': this.addCredentialParams.sessionServerVersionPlatform,
                'platformVersion': this.addCredentialParams.helpServiceExternalVersion
            }
        };
        this.openWindow.postMessage(JSON.stringify(emptyMessage), '*');
    };
    // construct the expect locale string. WDC expects it in this format
    // Taken from HelpService.ts::helpUrlLanguage
    OAuthCredentialsService.prototype.helpUrlLanguage = function (sessionLanguage) {
        switch (sessionLanguage) {
            case 'de': return 'de-de';
            case 'en': return 'en-us';
            case 'es': return 'es-es';
            case 'fr': return 'fr-fr';
            case 'ja': return 'ja-jp';
            case 'ko': return 'ko-kr';
            case 'pt': return 'pt-br';
            case 'zh': return 'zh-cn';
            default: return 'en-us';
        }
    };
    // Use the same regex in CookieHelper to get cookie value
    OAuthCredentialsService.prototype.getValueForCookie = function (name) {
        var parsedCookie = document.cookie.match('(?:^|;) ?' + name + '=([^;]*)(?:;|$)');
        return !parsedCookie || parsedCookie.length < 2 ? '' : parsedCookie[1];
    };
    OAuthCredentialsService.prototype.saveGenericAuthCredentials = function (responseObj) {
        var _this = this;
        var formData = new FormData();
        formData.append('data_class', this.addCredentialParams.connectionType);
        formData.append('username', responseObj.props.username);
        formData.append('password', responseObj.props.password);
        if (this.addCredentialParams.instanceUrl) {
            formData.append('instance_url', this.addCredentialParams.instanceUrl);
        }
        if (this.addCredentialParams.role) {
            formData.append('role', this.addCredentialParams.role);
        }
        if (responseObj.props.usernameAlias) {
            formData.append('username_alias', responseObj.props.usernameAlias);
        }
        var ajaxsettings = {
            url: OAuthCredentialsService.AddGenericAuthCredentialsPath,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'Content-Type': undefined,
                'X-XSRF-TOKEN': this.getValueForCookie('XSRF-TOKEN')
            },
            success: function (result) {
                _this.handleCustomOAuthResponse(result, responseObj);
            }
        };
        $.ajax(ajaxsettings);
    };
    OAuthCredentialsService.prototype.handleCustomOAuthResponse = function (response, responseObj) {
        var _this = this;
        var onExit = function () {
            _this.removeBeforeYouConnectDialog();
            _this.removeOpenWindow();
        };
        var errorCodeMatch = response.match(/errorCode=([^(&|")]*)/);
        if (errorCodeMatch) {
            var errorCode = parseInt(errorCodeMatch[1], 10) || 0;
            console.error('Error code ' + errorCode + ' returned from custom oauth response');
            onExit();
            return;
        }
        var newCredentialIdMatch = response.match(/id=([^(&|")]*)/);
        if (newCredentialIdMatch) {
            var newCredentialId = newCredentialIdMatch[1];
            var credentialProperties = (responseObj) ? responseObj.props : null;
            onExit();
            this.addCredentialParams.onCredentialAdded(newCredentialId, credentialProperties);
            return;
        }
        onExit();
    };
    OAuthCredentialsService.prototype.removeBeforeYouConnectDialog = function () {
        if (this.beforeYouConnectContainer) {
            this.beforeYouConnectContainer.remove();
            this.beforeYouConnectContainer = null;
        }
    };
    OAuthCredentialsService.prototype.removeOpenWindow = function () {
        if (this.addCredentialParams.shouldKeepWindowOpen) {
            // If the user specified to keep the window open, just return it here.
            return;
        }
        try {
            this.openWindow.close();
        }
        catch (e) {
            // Closing the window is best effort so there's nothing to do if it fails
        }
        this.hasOpenWindow = false;
    };
    OAuthCredentialsService.OAuthPath = '/auth/request_oauth';
    OAuthCredentialsService.WindowName = 'TableauAuth';
    OAuthCredentialsService.AddGenericAuthCredentialsPath = '/auth/add_generic_auth_credentials';
    OAuthCredentialsService.InitMsgName = 'init';
    OAuthCredentialsService.AuthPhaseName = 'auth';
    return OAuthCredentialsService;
}());
exports.OAuthCredentialsService = OAuthCredentialsService;
//# sourceMappingURL=OauthCredentialsService.js.map